import { z } from 'zod/v4'

/**
 * Roles of the users in a given data entity.
 * Follows pattern from https://firebase.google.com/docs/firestore/solutions/role-based-access
 */
export const Roles = {
	Owner: 'owner',
	Editor: 'editor',
	Viewer: 'viewer',
} as const

export type RoleKey = keyof typeof Roles

export const RoleValidator = z.enum([
        Roles.Owner,
        Roles.Editor,
        Roles.Viewer,
])

export const RoleObjectValidator = z.object({
        [Roles.Owner]: z.array(z.string()),
        [Roles.Editor]: z.array(z.string()),
        [Roles.Viewer]: z.array(z.string()),
})

export type RoleObject = z.infer<typeof RoleObjectValidator>

export enum Role {
	Owner = 'owner',
	Editor = 'editor',
	Viewer = 'viewer',
}

// this enum is used by the backend to determine which platform to use for targeting
export enum ThirdPartyPlatforms {
	GoogleCsv = 'google',
	All = 'all',
	GoogleSync = 'googleSync',
}

export enum CustomDataUploadTypes {
	Customer = 'customer',
	GoogleAds = 'google ads',
	MatchedLocations = 'matched locations',
}
